import React, { useEffect, useState } from 'react'
import {
  CheckboxUnit,
  DBFilterCheckboxArea,
  DBFilterWrapper,
  DBTableBtn,
  DBTableExcelBtn,
  DBTableResultTxt
} from '../DB/styles';
import { Checkbox, Table, message } from 'antd';
import EmployeeAdd from 'CRM/components/Add/EmployeeAdd';
import EmployeeEdit from 'CRM/components/Edit/EmployeeEdit';
import API from 'utils/api';
import { useToken } from 'app/hooks';
import {useIsMobile} from "../../components/IsMobile";

export const EmployeeTable = ({ employeeList, total, page, pageSize, setPage, setPageSize, mutate }) => {
  const IsMobile = useIsMobile();
  const [scrollPosition, setScrollPosition] = useState(0);
  const { data: token } = useToken();
  const [isAdd, setIsAdd] = useState(false)
  const [userId, setUserId] = useState(null);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectUser, setSelectUser] = useState<number[]>([]);

  useEffect(() => {
    if(!userId && IsMobile){
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    } else if(userId && IsMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setScrollPosition(window.scrollY);
    }
  }, [userId]);

  useEffect(() => {
    // console.log('employeeList', employeeList)
    // console.log('total', total)
    //
    const allSelected = employeeList?.length > 0 && employeeList?.every(it => selectUser?.includes(it.id));
    setIsAllChecked(allSelected);
  }, [selectUser, employeeList]);

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setSelectUser([...selectUser, id]);
    } else {
      setSelectUser(selectUser?.filter(rowId => rowId !== id));
    }
  };
  const handleSelectAllChange = (e) => {
    setIsAllChecked(e.target.checked);
    const ids = employeeList?.map(db => db.id);
    setSelectUser(e.target.checked ? ids : []);
  };


  const clickDelete = () => {
    const shouldEdit = window.confirm(`선택한 직원을 삭제하시겠습니까?`);
    if(shouldEdit) {
      if(selectUser?.length == 0) {
        message.error('선택한 직원이 없습니다.')
      } else {
        API.delete('/admin?userId=' + selectUser?.join(','), token + '', {})
        .then((res: any) => {
          if (res.result.success) {
            message.success('삭제되었습니다.')
            mutate();
          }else{
            message.error('삭제에 실패하였습니다.')
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const mobileColumns = [
    {
      dataIndex: 'checkbox',
      title: (
        <Checkbox
          checked={isAllChecked}
          onChange={handleSelectAllChange}
        />
      ),
      render: (value, data) => {
        return (
          <div className='checkbox' style={{textAlign: 'center'}}>
            <Checkbox checked={selectUser?.includes(data.id)} key={data?.id} onChange={(e) => handleCheckboxChange(e, data?.id)} />
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '직원',
      render: (value, data) => {
        return (
          <>
            <div className='name' onClick={() => setUserId(data?.id)} style={{color: '#437eff', cursor: 'pointer', justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>이름: </p> {data?.name || '-'}</div>
            <div className='tel' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>연락처: </p> {data?.tel || '-'}</div>
            <div className='path' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>관리자: </p> {data?.admin ? 'O' : 'X'}</div>
            <div className='path' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>팀장: </p> {data?.leader ? 'O' : 'X'}</div>
            <div className='path' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>팀명: </p>{data?.teamName || '-'}</div>
            <div className='date' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>아이디: </p> {data?.email || '-'}</div>
            <div className='date' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>비밀번호: </p> {data?.password || '-'}</div>
            <div className='memo' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>메모: </p> {data?.memo || '-'}</div>
          </>
        )
      }
    },
  ]

  const columns = [
    {
      dataIndex: 'checkbox',
      title: (
        <Checkbox
          checked={isAllChecked}
          onChange={handleSelectAllChange}
        />
      ),
      render: (value, data) => {
        return (
          <div className='checkbox' style={{textAlign: 'center'}}>
            <Checkbox checked={selectUser?.includes(data.id)} key={data?.id} onChange={(e) => handleCheckboxChange(e, data?.id)} />
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '이름',
      render: (value, data) => {
        return (
          <div className='name' onClick={() => setUserId(data?.id)} style={{color: '#437eff', textDecoration: 'underline', cursor: 'pointer'}}>
            {data?.name}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '연락처',
      render: (value, data) => {
        return (
          <div className='tel'>
            {data?.tel}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '관리자',
      render: (value, data) => {
        return (
          <div className='path'>
            {data?.admin ? 'O' : 'X'}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '팀장',
      render: (value, data) => {
        return (
          <div className='path'>
            {data?.leader ? 'O' : 'X'}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '팀명',
      render: (value, data) => {
        return (
          <div className='path'>
            {data?.teamName}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '아이디',
      render: (value, data) => {
        return (
          <div className='date'>
            {data?.email}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '비밀번호',
      render: (value, data) => {
        return (
          <div className='date'>
            {data?.password}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '메모',
      render: (value, data) => {
        return (
          <div className='memo'>
            {data?.memo}
          </div>
        )
      }
    },
  ];

  return (
    <DBFilterWrapper>
      <DBFilterCheckboxArea IsMobile={IsMobile}>
        <CheckboxUnit >
          <DBTableResultTxt IsMobile={IsMobile}>조회결과: 총 <span>{total || 0}</span> 명</DBTableResultTxt>
        </CheckboxUnit>
        {IsMobile ?
          <div style={{display: 'flex', gap: 10}}>
            <DBTableBtn color={'#437eff'} border={'#437eff'}  onClick={() => setIsAdd(true)} style={{backgroundColor: '#437eff', color: '#fff'}}>
              직원 등록
            </DBTableBtn>
            <DBTableBtn color={'#f93e3e'} border={'#f93e3e'} onClick={clickDelete} style={{backgroundColor: '#f93e3e', color: '#fff'}}>
              선택 직원 삭제
            </DBTableBtn>
          </div>
          :
          <div style={{display: 'flex', gap: 10}}>
            <DBTableExcelBtn onClick={() => setIsAdd(true)} style={{backgroundColor: '#437eff', color: '#fff'}}>
              직원 등록
            </DBTableExcelBtn>
            <DBTableExcelBtn onClick={clickDelete} style={{backgroundColor: '#f93e3e', color: '#fff'}}>
              선택 직원 삭제
            </DBTableExcelBtn>
          </div>
        }

      </DBFilterCheckboxArea>

      <Table className={`${IsMobile ? '' : 'DBTable' }`}
             dataSource={employeeList}
             columns={IsMobile ? mobileColumns : columns}
             pagination={{
               current: page,
               pageSize: pageSize,
               total: total,
             }}
             bordered={true}
             onChange={handleTableChange}
      />


      {isAdd && <EmployeeAdd setIsAdd={setIsAdd} mutate={mutate} />}
      {userId !== null && <EmployeeEdit userId={userId} setUserId={setUserId} mutate={mutate} />}
    </DBFilterWrapper>
  )
}

export default React.memo(EmployeeTable);